export default defineNuxtRouteMiddleware(async () => {
  const runTimeConfig = useRuntimeConfig();
  const dash = useDashboardStore();
  const cookie = useCookie("userToken");

  if (process.client) {
  try {
    if (!cookie.value && !dash.getIsUserConnected) {
      return;
    }
    const newNotification = await $fetch<number>("/users/get-new-notification-number", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${cookie.value}`,
      },
      baseURL: runTimeConfig.public.baseUrl,
    });

    if (process.client && !dash.getIsUserConnected) {
      await dash.fetchUserByToken();
    }

    if(Number(newNotification) > 0 && dash.userProfil.newNotificationsNumber < Number(newNotification)){
     
      dash.userProfil.newNotificationsNumber += Number(newNotification);

    }
    
  } catch (error) {
    console.error("Error fetching new notifications number:", error);
  }
  }
});
